<div class="container">
  <app-tab-view [(tabIndex)]="tabIndex" (tabIndexChange)="onTabChange($event)" [tabHeadersIcons]="tabHeadersIcons" [tabHeaders]="tabHeaders"></app-tab-view>
  <div class="tab-container" *ngIf="tabIndex === 0"><ng-content select="[tab0]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 1"><ng-content select="[tab1]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 2"><ng-content select="[tab2]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 3"><ng-content select="[tab3]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 4"><ng-content select="[tab4]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 5"><ng-content select="[tab5]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 6"><ng-content select="[tab6]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 7"><ng-content select="[tab7]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 8"><ng-content select="[tab8]"></ng-content></div>
  <div class="tab-container" *ngIf="tabIndex === 9"><ng-content select="[tab9]"></ng-content></div>
</div>
